var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "input-disable": _vm.isLoading,
        "modal fade show": _vm.getIsCanShowCreateAgent,
      },
      style: [
        _vm.getIsCanShowCreateAgent && {
          display: "block",
          overflowY: "scroll",
        },
      ],
      attrs: { id: "go-modal-create-agent", tabindex: "-1" },
    },
    [
      _c(
        "div",
        {
          class: [
            {
              "modal-dialog go-modal-goover-create":
                _vm.getIsCanShowCreateAgent,
            },
            {
              select:
                _vm.currentTab === _vm.allSelectTab[0] &&
                !_vm.isShowSelectChat &&
                _vm.getIsCanShowCreateAgent,
            },
            {
              report:
                (_vm.currentTab === _vm.allSelectTab[1] ||
                  _vm.currentTab === _vm.allSelectTab[2] ||
                  _vm.currentTab === _vm.allSelectTab[3]) &&
                !_vm.isShowSelectChat &&
                _vm.getIsCanShowCreateAgent,
            },
            { include: _vm.isShowSelectChat && _vm.getIsCanShowCreateAgent },
            {
              channel:
                !_vm.isShowSelectChat &&
                _vm.currentTab === _vm.allSelectTab[6] &&
                _vm.getIsCanShowCreateAgent,
            },
            {
              tab:
                !_vm.isShowSelectChat &&
                _vm.currentTab === _vm.allSelectTab[6] &&
                _vm.getIsCanShowCreateAgent &&
                _vm.selectedTab.includes(_vm.allSelectTab[5]),
            },
          ],
        },
        [
          _c(
            "div",
            { class: { "modal-content": _vm.getIsCanShowCreateAgent } },
            [
              _vm.getIsCanShowCreateAgent
                ? _c("div", { staticClass: "modal-header" }, [
                    !_vm.isShowSelectChat
                      ? _c(
                          "div",
                          {
                            staticClass: "go-text-wrap",
                            class: {
                              "inline-display-flex":
                                _vm.currentTab !== _vm.allSelectTab[0],
                            },
                          },
                          [
                            _c("div", { staticClass: "modal-title" }, [
                              _vm._v("GO OVER"),
                            ]),
                            _vm._v(" "),
                            _vm.currentTab !== _vm.allSelectTab[0]
                              ? _c("div", { staticClass: "go-step-wrap" }, [
                                  _c("dl", [
                                    _c("dt", [
                                      _c("em"),
                                      _vm._v(" "),
                                      _vm.selectedTab.includes(
                                        _vm.allSelectTab[1]
                                      ) ||
                                      _vm.selectedTab.includes(
                                        _vm.allSelectTab[2]
                                      ) ||
                                      _vm.selectedTab.includes(
                                        _vm.allSelectTab[3]
                                      ) ||
                                      _vm.selectedTab.includes(
                                        _vm.allSelectTab[4]
                                      )
                                        ? _c("em", {
                                            class: {
                                              active:
                                                _vm.currentTab ===
                                                  _vm.allSelectTab[1] ||
                                                _vm.currentTab ===
                                                  _vm.allSelectTab[2] ||
                                                _vm.currentTab ===
                                                  _vm.allSelectTab[3] ||
                                                _vm.currentTab ===
                                                  _vm.allSelectTab[4],
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedTab.includes(
                                        _vm.allSelectTab[5]
                                      )
                                        ? _c("em", {
                                            class: {
                                              active:
                                                _vm.currentTab ===
                                                _vm.allSelectTab[5],
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedTab.includes(
                                        _vm.allSelectTab[6]
                                      )
                                        ? _c("em", {
                                            class: {
                                              active:
                                                _vm.currentTab ===
                                                _vm.allSelectTab[6],
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("em", {
                                        class: {
                                          active:
                                            _vm.currentTab === _vm.END_TAB,
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("modal-create-agent.t7")
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "b",
                                        {
                                          staticStyle: { "margin-left": "5px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getCurrentStepNumber())
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "/" +
                                          _vm._s(_vm.getTotalSteps()) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _c("p", [_vm._v(_vm._s(_vm.$t("cdHome.t48")))]),
                          ]
                        )
                      : _c("div", { staticClass: "modal-title" }, [
                          _c(
                            "a",
                            {
                              staticClass: "modal-title-btn-back",
                              class: { noInteraction: _vm.isLoading },
                              on: {
                                click: _vm.handleBackMenuAndResetCheckedChat,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "go-icon-24 go-icon-arrow-left",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("em", [_vm._v(_vm._s(_vm.$t("cdHome.t81")))]),
                        ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-icon close",
                        attrs: {
                          disabled: _vm.isLoading,
                          "data-dismiss": "modal",
                          type: "button",
                        },
                        on: { click: _vm.closeModal },
                      },
                      [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isShowSelectChat &&
              _vm.currentTab !== _vm.allSelectTab[6] &&
              _vm.getIsCanShowCreateAgent
                ? _c("div", { staticClass: "modal-body" }, [
                    _vm.currentTab === _vm.allSelectTab[5]
                      ? _c("div", { staticClass: "go-form-title" }, [
                          _c("strong", [_vm._v(_vm._s(_vm.$t("cdHome.t49")))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("cdHome.t147")))]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "go-block-wrap" },
                      [
                        _c(
                          "vue-custom-scrollbar",
                          { staticClass: "go-modal-inner overflow-y-scroll" },
                          [
                            _vm.currentTab === _vm.allSelectTab[0]
                              ? _c("div", { staticClass: "go-block-body" }, [
                                  !_vm.getIsForNewBriefing
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "go-list-content select",
                                        },
                                        [
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(_vm.$t("cdHome.t104"))
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "go-list-item" },
                                            [
                                              _c("ul", [
                                                _c("li", [
                                                  _c("dl", [
                                                    _c("dt", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "custom-control custom-checkbox",
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "custom-control-input",
                                                            attrs: {
                                                              id: "customCheck-card-1",
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              checked:
                                                                _vm.selectedTab.includes(
                                                                  _vm
                                                                    .allSelectTab[1]
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleSelectTab(
                                                                  _vm
                                                                    .allSelectTab[1]
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("label", {
                                                            staticClass:
                                                              "custom-control-label",
                                                            attrs: {
                                                              for: "customCheck-card-1",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("dd", [
                                                      _c("strong", [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t105"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t106"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]),
                                                ]),
                                                _vm._v(" "),
                                                _c("li", [
                                                  _c("dl", [
                                                    _c("dt", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "custom-control custom-checkbox",
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "custom-control-input",
                                                            attrs: {
                                                              id: "customCheck-card-2",
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              checked:
                                                                _vm.selectedTab.includes(
                                                                  _vm
                                                                    .allSelectTab[2]
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleSelectTab(
                                                                  _vm
                                                                    .allSelectTab[2]
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("label", {
                                                            staticClass:
                                                              "custom-control-label",
                                                            attrs: {
                                                              for: "customCheck-card-2",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("dd", [
                                                      _c("strong", [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t107"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t108"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]),
                                                ]),
                                                _vm._v(" "),
                                                _c("li", [
                                                  _c("dl", [
                                                    _c("dt", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "custom-control custom-checkbox",
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "custom-control-input",
                                                            attrs: {
                                                              id: "customCheck-card-3",
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              checked:
                                                                _vm.selectedTab.includes(
                                                                  _vm
                                                                    .allSelectTab[3]
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleSelectTab(
                                                                  _vm
                                                                    .allSelectTab[3]
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("label", {
                                                            staticClass:
                                                              "custom-control-label",
                                                            attrs: {
                                                              for: "customCheck-card-3",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("dd", [
                                                      _c("strong", [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t109"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t110"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]),
                                                ]),
                                                _vm._v(" "),
                                                _c("li", [
                                                  _c("dl", [
                                                    _c("dt", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "custom-control custom-checkbox",
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "custom-control-input",
                                                            attrs: {
                                                              id: "customCheck-card-4",
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              checked:
                                                                _vm.selectedTab.includes(
                                                                  _vm
                                                                    .allSelectTab[4]
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleSelectTab(
                                                                  _vm
                                                                    .allSelectTab[4]
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("label", {
                                                            staticClass:
                                                              "custom-control-label",
                                                            attrs: {
                                                              for: "customCheck-card-4",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("dd", [
                                                      _c("div", [
                                                        _c("strong", [
                                                          _c("em", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t111"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]),
                                                        _vm._v(" "),
                                                        _vm.selectedTab.includes(
                                                          _vm.allSelectTab[4]
                                                        ) &&
                                                        _vm.isReachLimitCreation
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "alert-limit-creation",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              (" +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "briefing.popup.createBriefing.reportTypeSelect.alert.inDepthReport"
                                                                      )
                                                                    ) +
                                                                    ")"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t112"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "go-list-content select" },
                                    [
                                      _c("h3", [
                                        _vm._v(_vm._s(_vm.$t("cdHome.t113"))),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "go-list-item" },
                                        [
                                          _c("ul", [
                                            _c("li", [
                                              _c("dl", [
                                                _c("dt", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-control custom-checkbox",
                                                      class: {
                                                        "input-disable":
                                                          _vm.getIsForNewBriefing,
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "custom-control-input",
                                                        class: {
                                                          "input-disable":
                                                            _vm.getIsForNewBriefing,
                                                        },
                                                        attrs: {
                                                          id: "customCheck-card-5",
                                                          disabled:
                                                            _vm.getIsForNewBriefing,
                                                          type: "checkbox",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.selectedTab.includes(
                                                              _vm
                                                                .allSelectTab[5]
                                                            ) ||
                                                            _vm.getIsForNewBriefing,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleSelectTab(
                                                              _vm
                                                                .allSelectTab[5]
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("label", {
                                                        staticClass:
                                                          "custom-control-label",
                                                        attrs: {
                                                          for: "customCheck-card-5",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("dd", [
                                                  _c("strong", [
                                                    _c("em", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("cdHome.t114")
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("cdHome.t115")
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "go-list-item" },
                                        [
                                          _c("ul", [
                                            _c("li", [
                                              _c("dl", [
                                                _c("dt", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-control custom-checkbox",
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "custom-control-input",
                                                        attrs: {
                                                          id: "customCheck-card-6",
                                                          type: "checkbox",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.selectedTab.includes(
                                                              _vm
                                                                .allSelectTab[6]
                                                            ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleSelectTab(
                                                              _vm
                                                                .allSelectTab[6]
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("label", {
                                                        staticClass:
                                                          "custom-control-label",
                                                        attrs: {
                                                          for: "customCheck-card-6",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("dd", [
                                                  _c("strong", [
                                                    _c("em", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("cdHome.t116")
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("cdHome.t117")
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : (_vm.currentTab === _vm.allSelectTab[1] ||
                                  _vm.currentTab === _vm.allSelectTab[2] ||
                                  _vm.currentTab === _vm.allSelectTab[3] ||
                                  _vm.currentTab === _vm.allSelectTab[4]) &&
                                !_vm.getIsForNewBriefing
                              ? _c("div", { staticClass: "go-block-body" }, [
                                  _c(
                                    "div",
                                    { staticClass: "go-list-content form" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "go-form-title",
                                          staticStyle: { "margin-left": "0" },
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("cdHome.t118"))
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "go-form-group" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "go-block-between" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "go-form-label",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("cdHome.t119")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "go-info-inline",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-form-group",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t120",
                                                              {
                                                                selected:
                                                                  _vm
                                                                    .listMessageIdsFocus
                                                                    .length / 2,
                                                                total:
                                                                  _vm
                                                                    .tempListTitleMessage
                                                                    .length / 2,
                                                              }
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn go-btn-default",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.isShowSelectChat = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t121"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.selectedTab.includes(
                                        _vm.allSelectTab[1]
                                      )
                                        ? _c("fieldset", [
                                            _c("legend", [
                                              _vm._v(
                                                _vm._s(_vm.$t("cdHome.t124"))
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "go-form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "go-form-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("cdHome.t125")
                                                      ) + " "
                                                    ),
                                                    _c("sup", [_vm._v("*")]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-block-between",
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.reportTypeSelected,
                                                            expression:
                                                              "reportTypeSelected",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "go-form-control center-arrow-dropdown",
                                                        on: {
                                                          change: [
                                                            function ($event) {
                                                              var $$selectedVal =
                                                                Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      var val =
                                                                        "_value" in
                                                                        o
                                                                          ? o._value
                                                                          : o.value
                                                                      return val
                                                                    }
                                                                  )
                                                              _vm.reportTypeSelected =
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                            },
                                                            function ($event) {
                                                              return _vm.toggleReportType(
                                                                _vm.reportTypeSelected
                                                              )
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .reportTypes[0],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t126"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .reportTypes[2],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t127"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .reportTypes[1],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t128"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .reportTypes[10],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t129"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.reportStyleSelected,
                                                            expression:
                                                              "reportStyleSelected",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "go-form-control center-arrow-dropdown",
                                                        on: {
                                                          change: [
                                                            function ($event) {
                                                              var $$selectedVal =
                                                                Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      var val =
                                                                        "_value" in
                                                                        o
                                                                          ? o._value
                                                                          : o.value
                                                                      return val
                                                                    }
                                                                  )
                                                              _vm.reportStyleSelected =
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                            },
                                                            function ($event) {
                                                              return _vm.toggleReportType(
                                                                _vm.reportTypeSelected
                                                              )
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .optionReportTypes[1],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t130"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm.reportTypeSelected ===
                                                                _vm
                                                                  .reportTypes[10],
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .optionReportTypes[2],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "cdHome.t131"
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.reportTypesResult.includes(
                                                  _vm.reportTypes[10]
                                                ) && _vm.isReachLimitCreation
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "alert-limit-creation",
                                                        staticStyle: {
                                                          display: "block",
                                                          "margin-top":
                                                            "0.25rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      (" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "briefing.popup.createBriefing.reportTypeSelect.alert.inDepthReport"
                                                              )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "go-form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "go-form-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("cdHome.t132")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.promptReportFocus,
                                                      expression:
                                                        "promptReportFocus",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "go-form-control",
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t("cdHome.t133"),
                                                    maxlength: "1000",
                                                    rows: "3",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.promptReportFocus,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.promptReportFocus =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "go-form-help",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.promptReportFocus
                                                          .length
                                                      ) + " / 1000"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "go-form-feedback-help",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t("cdHome.t134")
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedTab.includes(
                                        _vm.allSelectTab[2]
                                      )
                                        ? _c("fieldset", [
                                            _c("legend", [
                                              _vm._v(
                                                _vm._s(_vm.$t("cdHome.t135"))
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "go-form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "go-form-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("cdHome.t136")
                                                      )
                                                    ),
                                                    _c("sup", [_vm._v("*")]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-block-between",
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.journalistNoteStyleResult,
                                                            expression:
                                                              "journalistNoteStyleResult",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "go-form-control center-arrow-dropdown",
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$selectedVal =
                                                              Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function (o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function (
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                            _vm.journalistNoteStyleResult =
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .reportTypes[7],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t130"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .reportTypes[3],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t131"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedTab.includes(
                                        _vm.allSelectTab[3]
                                      )
                                        ? _c("fieldset", [
                                            _c("legend", [
                                              _vm._v(
                                                _vm._s(_vm.$t("cdHome.t109"))
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "go-form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "go-form-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("cdHome.t136")
                                                      )
                                                    ),
                                                    _c("sup", [_vm._v("*")]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-block-between",
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.socialMediaPostingStyleResult,
                                                            expression:
                                                              "socialMediaPostingStyleResult",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "go-form-control center-arrow-dropdown",
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$selectedVal =
                                                              Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function (o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function (
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                            _vm.socialMediaPostingStyleResult =
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .reportTypes[8],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t137"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .reportTypes[11],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t138"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .reportTypes[12],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t139"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .reportTypes[13],
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t140"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedTab.includes(
                                        _vm.allSelectTab[4]
                                      )
                                        ? _c("fieldset", [
                                            _c("legend", [
                                              _vm._v(
                                                _vm._s(_vm.$t("cdHome.t141"))
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "pod-cast-drop" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "go-panel" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-panel-body",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "pod-cast-wrap",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "pod-cast-header",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "cdHome.t142"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "pod-cast-select",
                                                              },
                                                              [
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn go-btn-icon host-nav-btn nav-btn-circle",
                                                                    attrs: {
                                                                      disabled:
                                                                        _vm.currentPage ===
                                                                        0,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.prevPage,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "go-icon-24 go-icon-chevron-left",
                                                                    }),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm._l(
                                                                  _vm.displayedHosts,
                                                                  function (
                                                                    podcastHost,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "dl",
                                                                      {
                                                                        key:
                                                                          "podcast_" +
                                                                          index,
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "dt",
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "go-user-thumb",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        src: podcastHost.narratorImg,
                                                                                        alt: _vm.$t(
                                                                                          "modal-create-agent.t15"
                                                                                        ),
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "go-user-name",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      podcastHost.narratorName
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "dd",
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "custom-control custom-radio",
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.changeHostAudioSelected(
                                                                                        podcastHost
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "input",
                                                                                  {
                                                                                    staticClass:
                                                                                      "custom-control-input",
                                                                                    attrs:
                                                                                      {
                                                                                        id:
                                                                                          "modelCheckHost" +
                                                                                          (_vm.currentPage *
                                                                                            _vm.hostsPerPage +
                                                                                            index),
                                                                                        name: "hostAudioSelection",
                                                                                        type: "radio",
                                                                                      },
                                                                                    domProps:
                                                                                      {
                                                                                        checked:
                                                                                          _vm
                                                                                            .hostAudioSelected
                                                                                            .narratorId ===
                                                                                          podcastHost.narratorId,
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.changeHostAudioSelected(
                                                                                            podcastHost
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "label",
                                                                                  {
                                                                                    staticClass:
                                                                                      "custom-control-label",
                                                                                    attrs:
                                                                                      {
                                                                                        for:
                                                                                          "modelCheckHost" +
                                                                                          (_vm.currentPage *
                                                                                            _vm.hostsPerPage +
                                                                                            index),
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn go-btn-icon host-nav-btn nav-btn-circle",
                                                                    attrs: {
                                                                      disabled:
                                                                        _vm.currentPage >=
                                                                        _vm.maxPage,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.nextPage,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "go-icon-24 go-icon-chevron-right",
                                                                    }),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "go-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .hostAudioSelected
                                                                      .narratorDescription ||
                                                                      ""
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "pod-cast-player",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "pod-cast-player-range",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm.playerProgress,
                                                                              expression:
                                                                                "playerProgress",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "go-form-range",
                                                                        attrs: {
                                                                          id: "customRange",
                                                                          max: "100",
                                                                          type: "range",
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              _vm.playerProgress,
                                                                          },
                                                                        on: {
                                                                          input:
                                                                            _vm.onProgressChange,
                                                                          __r: function (
                                                                            $event
                                                                          ) {
                                                                            _vm.playerProgress =
                                                                              $event.target.value
                                                                          },
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("p", [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.formatTime(
                                                                                _vm.currentTime
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.formatTime(
                                                                                _vm.totalTime
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "pod-cast-player-btn",
                                                                  },
                                                                  [
                                                                    _c("div", [
                                                                      _c(
                                                                        "button",
                                                                        {
                                                                          staticClass:
                                                                            "btn go-btn-icon active",
                                                                          attrs:
                                                                            {
                                                                              type: "button",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              _vm.togglePlay,
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "go-icon-24",
                                                                              class:
                                                                                _vm.isPlaying
                                                                                  ? "go-icon-player-pause-filled"
                                                                                  : "go-icon-player-play-filled",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("div", [
                                                                      _c(
                                                                        "button",
                                                                        {
                                                                          staticClass:
                                                                            "btn go-btn-icon",
                                                                          attrs:
                                                                            {
                                                                              type: "button",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              _vm.toggleMute,
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "go-icon-24",
                                                                              class:
                                                                                _vm.isMuted
                                                                                  ? "go-icon-volume-off"
                                                                                  : "go-icon-volume",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "go-form-group" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "go-block-between" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "go-form-label",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("cdHome.t143")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "go-info-inline",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-control custom-radio go-form-check-inline",
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.privacyReport,
                                                            expression:
                                                              "privacyReport",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "custom-control-input",
                                                        attrs: {
                                                          id: "go-option-public-report",
                                                          name: "briefingPublicPublic",
                                                          type: "radio",
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.privacyTypes[0],
                                                          checked: _vm._q(
                                                            _vm.privacyReport,
                                                            _vm.privacyTypes[0]
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            _vm.privacyReport =
                                                              _vm.privacyTypes[0]
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "go-option-public-report",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t144"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-control custom-radio go-form-check-inline",
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "custom-control-input",
                                                        attrs: {
                                                          id: "go-option-private-report",
                                                          name: "briefingPublicPrivate",
                                                          type: "radio",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.privacyReport ===
                                                            _vm.privacyTypes[1],
                                                          value:
                                                            _vm.privacyTypes[1],
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.validateAndChangePrivacyForReport(
                                                              $event,
                                                              _vm
                                                                .privacyTypes[1]
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "go-option-private-report",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t145"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm.currentTab === _vm.allSelectTab[5]
                              ? _c("div", { staticClass: "go-block-body" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "go-list-content form",
                                      staticStyle: { "overflow-x": "hidden" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "go-form-group" },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "go-form-label" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("cdHome.t148"))
                                              ),
                                              _c("sup", [_vm._v("*")]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "go-input-group" },
                                            [
                                              _vm.isLoadingGenerateData
                                                ? _c("b-spinner", {
                                                    staticStyle: {
                                                      position: "absolute",
                                                      top: "44%",
                                                      left: "3%",
                                                    },
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "modal-create-agent.t14"
                                                      ),
                                                      small: "",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.title,
                                                    expression: "title",
                                                  },
                                                ],
                                                staticClass: "go-form-control",
                                                attrs: {
                                                  disabled:
                                                    _vm.isLoadingGenerateData,
                                                  maxlength: 100,
                                                  type: "text",
                                                },
                                                domProps: { value: _vm.title },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.title =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "small",
                                            { staticClass: "go-form-help" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.title.length) +
                                                  " / 100"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("hr", { staticClass: "hr-2" }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "go-form-group data-source",
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "go-form-label" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("cdHome.t149")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "go-nav-select-list",
                                              staticStyle: {
                                                "align-items": "unset",
                                              },
                                            },
                                            [
                                              _c("ul", [
                                                _c(
                                                  "li",
                                                  {
                                                    class: {
                                                      noInteraction:
                                                        _vm.isLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.changeDataSource(
                                                          _vm.DATA_SOURCE_CHAT.BASIC.toString()
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-control custom-checkbox",
                                                      },
                                                      [
                                                        _c("input", {
                                                          staticClass:
                                                            "custom-control-input noInteraction",
                                                          attrs: {
                                                            id: "sourceCheck_BASIC",
                                                            disabled:
                                                              _vm.isLoading,
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              _vm.dataSource.includes(
                                                                _vm.DATA_SOURCE_CHAT.BASIC.toString()
                                                              ),
                                                          },
                                                          on: {
                                                            click: [
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "sourceCheck_BASIC",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _c("strong", [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t39"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("cdHome.t40")
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "li",
                                                  {
                                                    class: {
                                                      noInteraction:
                                                        _vm.isLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.changeDataSource(
                                                          _vm.DATA_SOURCE_CHAT.FINANCE.toString()
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-control custom-checkbox",
                                                      },
                                                      [
                                                        _c("input", {
                                                          staticClass:
                                                            "custom-control-input noInteraction",
                                                          attrs: {
                                                            id: "sourceCheck2",
                                                            disabled:
                                                              _vm.isLoading,
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              _vm.dataSource.includes(
                                                                _vm.DATA_SOURCE_CHAT.FINANCE.toString()
                                                              ),
                                                          },
                                                          on: {
                                                            click: [
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "sourceCheck2",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _c("strong", [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t21"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("cdHome.t22")
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "li",
                                                  {
                                                    class: {
                                                      noInteraction:
                                                        _vm.isLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.changeDataSource(
                                                          _vm.DATA_SOURCE_CHAT.RND.toString()
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-control custom-checkbox",
                                                      },
                                                      [
                                                        _c("input", {
                                                          staticClass:
                                                            "custom-control-input noInteraction",
                                                          attrs: {
                                                            id: "sourceCheck3",
                                                            disabled:
                                                              _vm.isLoading,
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              _vm.dataSource.includes(
                                                                _vm.DATA_SOURCE_CHAT.RND.toString()
                                                              ),
                                                          },
                                                          on: {
                                                            click: [
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "sourceCheck3",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _c("strong", [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t23"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("cdHome.t24")
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("ul", [
                                                _c(
                                                  "li",
                                                  {
                                                    class: {
                                                      noInteraction:
                                                        _vm.isLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.changeDataSource(
                                                          _vm.DATA_SOURCE_CHAT.PATENT.toString()
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-control custom-checkbox",
                                                      },
                                                      [
                                                        _c("input", {
                                                          staticClass:
                                                            "custom-control-input noInteraction",
                                                          attrs: {
                                                            id: "sourceCheck4",
                                                            disabled:
                                                              _vm.isLoading,
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              _vm.dataSource.includes(
                                                                _vm.DATA_SOURCE_CHAT.PATENT.toString()
                                                              ),
                                                          },
                                                          on: {
                                                            click: [
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "sourceCheck4",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _c("strong", [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t25"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("cdHome.t26")
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "li",
                                                  {
                                                    class: {
                                                      noInteraction:
                                                        _vm.isLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.changeDataSource(
                                                          _vm.DATA_SOURCE_CHAT.LAW.toString()
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-control custom-checkbox",
                                                      },
                                                      [
                                                        _c("input", {
                                                          staticClass:
                                                            "custom-control-input noInteraction",
                                                          attrs: {
                                                            id: "sourceCheck5",
                                                            disabled:
                                                              _vm.isLoading,
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              _vm.dataSource.includes(
                                                                _vm.DATA_SOURCE_CHAT.LAW.toString()
                                                              ),
                                                          },
                                                          on: {
                                                            click: [
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "sourceCheck5",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _c("strong", [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t27"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("cdHome.t28")
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("hr", { staticClass: "hr-2" }),
                                      _vm._v(" "),
                                      _c("fieldset", [
                                        _c("legend", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("modal-create-agent.t8")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "go-form-group" },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "go-form-label" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("cdHome.t125"))
                                                ),
                                                _c("sup", [_vm._v("*")]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "go-block-between",
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.reportTypeSelectedForBriefing,
                                                        expression:
                                                          "reportTypeSelectedForBriefing",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "go-form-control center-arrow-dropdown",
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.reportTypeSelectedForBriefing =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                        function ($event) {
                                                          return _vm.toggleReportTypeForBriefing(
                                                            _vm.reportTypeSelectedForBriefing
                                                          )
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value:
                                                            _vm.reportTypes[0],
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t126"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value:
                                                            _vm.reportTypes[2],
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t127"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value:
                                                            _vm.reportTypes[1],
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t128"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value:
                                                            _vm.reportTypes[10],
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t129"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.reportStyleSelectedForBriefing,
                                                        expression:
                                                          "reportStyleSelectedForBriefing",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "go-form-control center-arrow-dropdown",
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.reportStyleSelectedForBriefing =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                        function ($event) {
                                                          return _vm.toggleReportTypeForBriefing(
                                                            _vm.reportTypeSelectedForBriefing
                                                          )
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value:
                                                            _vm
                                                              .optionReportTypes[1],
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cdHome.t130"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.reportTypeSelectedForBriefing ===
                                                            _vm.reportTypes[10],
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm
                                                              .optionReportTypes[2],
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t131"
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.reportTypesResultForBriefing.includes(
                                              _vm.reportTypes[10]
                                            ) && _vm.isReachLimitCreation
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "alert-limit-creation",
                                                    staticStyle: {
                                                      display: "block",
                                                      "margin-top": "0.25rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      (" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "briefing.popup.createBriefing.reportTypeSelect.alert.inDepthReport"
                                                          )
                                                        ) +
                                                        ")"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "go-form-group" },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "go-form-label" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("cdHome.t132"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.promptReportFocusForBriefing,
                                                  expression:
                                                    "promptReportFocusForBriefing",
                                                },
                                              ],
                                              staticClass: "go-form-control",
                                              attrs: {
                                                placeholder:
                                                  _vm.$t("cdHome.t133"),
                                                maxlength: "1000",
                                                rows: "3",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.promptReportFocusForBriefing,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.promptReportFocusForBriefing =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "go-form-help" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .promptReportFocusForBriefing
                                                      .length
                                                  ) + " / 1000"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "go-form-feedback-help",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("cdHome.t134")
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "go-form-group" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "go-block-between" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "go-form-label",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("cdHome.t150")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "go-info-inline",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-control custom-radio go-form-check-inline",
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.privacy,
                                                            expression:
                                                              "privacy",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "custom-control-input",
                                                        attrs: {
                                                          id: "go-option-public-agent",
                                                          checked: "",
                                                          name: "agentPublicPublic",
                                                          type: "radio",
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.privacyTypes[0],
                                                          checked: _vm._q(
                                                            _vm.privacy,
                                                            _vm.privacyTypes[0]
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            _vm.privacy =
                                                              _vm.privacyTypes[0]
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "go-option-public-agent",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t144"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-control custom-radio go-form-check-inline",
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "custom-control-input",
                                                        attrs: {
                                                          id: "go-option-private-agent",
                                                          name: "agentPublicPrivate",
                                                          type: "radio",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.privacy ===
                                                            _vm.privacyTypes[1],
                                                          value:
                                                            _vm.privacyTypes[1],
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.validateAndChangePrivacy(
                                                              $event,
                                                              _vm
                                                                .privacyTypes[1]
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "go-option-private-agent",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t145"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm.currentTab === _vm.END_TAB
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "go-block-body",
                                    staticStyle: { height: "100%" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "go-list-content progress custom-progress",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "create-answer" },
                                          [
                                            _c("p", [
                                              _c("span", [
                                                _vm.LOADING_CREATE.ALL.isTimeOut
                                                  ? _c("i", {
                                                      staticClass:
                                                        "go-icon-32 go-icon-close",
                                                    })
                                                  : _vm.LOADING_CREATE.ALL
                                                      .isUse &&
                                                    !_vm.LOADING_CREATE.ALL
                                                      .isLoading &&
                                                    _vm.LOADING_CREATE.ALL
                                                      .isSuccess
                                                  ? _c("i", {
                                                      staticClass:
                                                        "go-icon-32 go-icon-check",
                                                    })
                                                  : _c("i", {
                                                      staticClass:
                                                        "go-icon-24 go-spinner custom-go-spinner",
                                                      staticStyle: {
                                                        margin: "0 !important",
                                                      },
                                                    }),
                                              ]),
                                              _vm._v(" "),
                                              _vm.LOADING_CREATE.ALL.isTimeOut
                                                ? _c(
                                                    "strong",
                                                    {
                                                      staticStyle: {
                                                        "margin-top": "23px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "modal-create-agent.t9"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm.LOADING_CREATE.ALL
                                                    .isUse &&
                                                  !_vm.LOADING_CREATE.ALL
                                                    .isLoading &&
                                                  _vm.LOADING_CREATE.ALL
                                                    .isSuccess
                                                ? _c(
                                                    "strong",
                                                    {
                                                      staticStyle: {
                                                        "margin-top": "23px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "modal-create-agent.t10"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "strong",
                                                    {
                                                      staticStyle: {
                                                        "margin-top": "23px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("cdHome.t164")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ]),
                                            _vm._v(" "),
                                            _c("hr"),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticStyle: {
                                                  height: "52%",
                                                  "justify-content": "center",
                                                },
                                              },
                                              [
                                                _vm.selectedTab.includes(
                                                  _vm.allSelectTab[1]
                                                )
                                                  ? _c("li", [
                                                      _c("em", [
                                                        _vm.LOADING_CREATE
                                                          .REPORT.isTimeOut
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-close",
                                                            })
                                                          : _vm.LOADING_CREATE
                                                              .REPORT.isUse &&
                                                            !_vm.LOADING_CREATE
                                                              .REPORT
                                                              .isLoading &&
                                                            _vm.LOADING_CREATE
                                                              .REPORT.isSuccess
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-check",
                                                            })
                                                          : _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-spinner custom-go-spinner",
                                                            }),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.LOADING_CREATE.REPORT
                                                        .isUse &&
                                                      !_vm.LOADING_CREATE.REPORT
                                                        .isLoading &&
                                                      _vm.LOADING_CREATE.REPORT
                                                        .isSuccess
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "link-to-page",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.goToListPage(
                                                                      _vm.LOADING_DATA_TYPE.REPORT.toString()
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.goToPage
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.reportCreatingText
                                                              )
                                                            ),
                                                          ]),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.selectedTab.includes(
                                                  _vm.allSelectTab[2]
                                                )
                                                  ? _c("li", [
                                                      _c("em", [
                                                        _vm.LOADING_CREATE
                                                          .JOURNALIST_NOTE
                                                          .isTimeOut
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-close",
                                                            })
                                                          : _vm.LOADING_CREATE
                                                              .JOURNALIST_NOTE
                                                              .isUse &&
                                                            !_vm.LOADING_CREATE
                                                              .JOURNALIST_NOTE
                                                              .isLoading &&
                                                            _vm.LOADING_CREATE
                                                              .JOURNALIST_NOTE
                                                              .isSuccess
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-check",
                                                            })
                                                          : _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-spinner custom-go-spinner",
                                                            }),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.LOADING_CREATE
                                                        .JOURNALIST_NOTE
                                                        .isUse &&
                                                      !_vm.LOADING_CREATE
                                                        .JOURNALIST_NOTE
                                                        .isLoading &&
                                                      _vm.LOADING_CREATE
                                                        .JOURNALIST_NOTE
                                                        .isSuccess
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "link-to-page",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.goToListPage(
                                                                      _vm.LOADING_DATA_TYPE.JOURNALIST_NOTE.toString()
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "modal-create-agent.t5"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t166"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.selectedTab.includes(
                                                  _vm.allSelectTab[3]
                                                )
                                                  ? _c("li", [
                                                      _c("em", [
                                                        _vm.LOADING_CREATE
                                                          .SOCIAL_MEDIA_POSTING
                                                          .isTimeOut
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-close",
                                                            })
                                                          : _vm.LOADING_CREATE
                                                              .SOCIAL_MEDIA_POSTING
                                                              .isUse &&
                                                            !_vm.LOADING_CREATE
                                                              .SOCIAL_MEDIA_POSTING
                                                              .isLoading &&
                                                            _vm.LOADING_CREATE
                                                              .SOCIAL_MEDIA_POSTING
                                                              .isSuccess
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-check",
                                                            })
                                                          : _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-spinner custom-go-spinner",
                                                            }),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.LOADING_CREATE
                                                        .SOCIAL_MEDIA_POSTING
                                                        .isUse &&
                                                      !_vm.LOADING_CREATE
                                                        .SOCIAL_MEDIA_POSTING
                                                        .isLoading &&
                                                      _vm.LOADING_CREATE
                                                        .SOCIAL_MEDIA_POSTING
                                                        .isSuccess
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "link-to-page",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.goToListPage(
                                                                      _vm.LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString()
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "modal-create-agent.t4"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t187"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.selectedTab.includes(
                                                  _vm.allSelectTab[4]
                                                )
                                                  ? _c("li", [
                                                      _c("em", [
                                                        _vm.LOADING_CREATE
                                                          .PODCAST.isTimeOut
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-close",
                                                            })
                                                          : _vm.LOADING_CREATE
                                                              .PODCAST.isUse &&
                                                            !_vm.LOADING_CREATE
                                                              .PODCAST
                                                              .isLoading &&
                                                            _vm.LOADING_CREATE
                                                              .PODCAST.isSuccess
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-check",
                                                            })
                                                          : _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-spinner custom-go-spinner",
                                                            }),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.LOADING_CREATE.PODCAST
                                                        .isUse &&
                                                      !_vm.LOADING_CREATE
                                                        .PODCAST.isLoading &&
                                                      _vm.LOADING_CREATE.PODCAST
                                                        .isSuccess
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "link-to-page",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.goToListPage(
                                                                      _vm.LOADING_DATA_TYPE.PODCAST.toString()
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "modal-create-agent.t3"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t167"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.selectedTab.includes(
                                                  _vm.allSelectTab[5]
                                                )
                                                  ? _c("li", [
                                                      _c("em", [
                                                        _vm.LOADING_CREATE
                                                          .REPORT_BRIEFING
                                                          .isTimeOut
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-close",
                                                            })
                                                          : _vm.LOADING_CREATE
                                                              .REPORT_BRIEFING
                                                              .isUse &&
                                                            !_vm.LOADING_CREATE
                                                              .REPORT_BRIEFING
                                                              .isLoading &&
                                                            _vm.LOADING_CREATE
                                                              .REPORT_BRIEFING
                                                              .isSuccess
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-check",
                                                            })
                                                          : _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-spinner custom-go-spinner",
                                                            }),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.LOADING_CREATE
                                                        .REPORT_BRIEFING
                                                        .isUse &&
                                                      !_vm.LOADING_CREATE
                                                        .REPORT_BRIEFING
                                                        .isLoading &&
                                                      _vm.LOADING_CREATE
                                                        .REPORT_BRIEFING
                                                        .isSuccess
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "link-to-page",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.goToListPage(
                                                                      _vm.LOADING_DATA_TYPE.BRIEFING_AGENT.toString()
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "modal-create-agent.t2"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t168"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.selectedTab.includes(
                                                  _vm.allSelectTab[6]
                                                ) && _vm.isCanCreateScrapAgent
                                                  ? _c("li", [
                                                      _c("em", [
                                                        _vm.LOADING_CREATE
                                                          .SCRAP_AGENT.isTimeOut
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-close",
                                                            })
                                                          : _vm.LOADING_CREATE
                                                              .SCRAP_AGENT
                                                              .isUse &&
                                                            !_vm.LOADING_CREATE
                                                              .SCRAP_AGENT
                                                              .isLoading &&
                                                            _vm.LOADING_CREATE
                                                              .SCRAP_AGENT
                                                              .isSuccess
                                                          ? _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-check",
                                                            })
                                                          : _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-spinner custom-go-spinner",
                                                            }),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.LOADING_CREATE
                                                        .SCRAP_AGENT.isUse &&
                                                      !_vm.LOADING_CREATE
                                                        .SCRAP_AGENT
                                                        .isLoading &&
                                                      _vm.LOADING_CREATE
                                                        .SCRAP_AGENT.isSuccess
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "link-to-page",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.goToListPage(
                                                                      _vm.LOADING_DATA_TYPE.CONNECT_AGENT.toString()
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "modal-create-agent.t1"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cdHome.t169"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("hr"),
                                            _vm._v(" "),
                                            !(
                                              _vm.LOADING_CREATE.ALL.isUse &&
                                              !_vm.LOADING_CREATE.ALL
                                                .isLoading &&
                                              _vm.LOADING_CREATE.ALL.isSuccess
                                            )
                                              ? _c("div", {
                                                  staticStyle: {
                                                    "font-size": "14px",
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t("cdHome.t170")
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm.isShowSelectChat && _vm.getIsCanShowCreateAgent
                ? _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      {
                        staticClass: "go-list-wrap",
                        staticStyle: { height: "100% !important" },
                      },
                      [
                        _c(
                          "vue-custom-scrollbar",
                          { staticClass: "go-modal-inner overflow-y-scroll" },
                          [
                            _c("div", { staticClass: "go-block-body" }, [
                              _c("div", { staticClass: "go-card-sub-wrap" }, [
                                _c("div", { staticClass: "go-form-group" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox",
                                      class: { noInteraction: _vm.isLoading },
                                      on: {
                                        click: function ($event) {
                                          return _vm.checkAllChat()
                                        },
                                      },
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          id: "customCheck-all",
                                          disabled: _vm.isLoading,
                                          type: "checkbox",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.tempCheckedListMessageIdsFocus &&
                                            _vm.tempCheckedListMessageIdsFocus
                                              .length > 0 &&
                                            _vm.tempCheckedListMessageIdsFocus
                                              .length ===
                                              _vm.tempListTitleMessage.length,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "customCheck-all" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("cdHome.t82")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "go-card-sub-list go-card-reference2",
                                  },
                                  _vm._l(
                                    _vm.tempListTitleMessage,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          staticClass: "go-list-item",
                                          class: {
                                            noInteraction: _vm.isLoading,
                                          },
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.changeMessageId(
                                                item,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          item.role ===
                                          _vm.ROLE_CHAT.USER.toString()
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "go-card-header",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-control custom-checkbox",
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "custom-control-input",
                                                        attrs: {
                                                          id:
                                                            "customCheck" +
                                                            index,
                                                          disabled:
                                                            _vm.isLoading,
                                                          type: "checkbox",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.tempCheckedListMessageIdsFocus.includes(
                                                              item.messageId
                                                            ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("label", {
                                                        staticClass:
                                                          "custom-control-label",
                                                        attrs: {
                                                          for:
                                                            "customCheck" +
                                                            index,
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.role ===
                                          _vm.ROLE_CHAT.USER.toString()
                                            ? _c(
                                                "div",
                                                { staticClass: "go-card-sub" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-card-body",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "go-block-body",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "go-block-wrap",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "go-card-title",
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "left",
                                                                    width:
                                                                      "100%",
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "go-icon-24 go-icon-letter-q",
                                                                    }),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      class: {
                                                                        showTextOver:
                                                                          _vm.noTruncatedIdsList.includes(
                                                                            item.messageId
                                                                          ),
                                                                      },
                                                                      attrs: {
                                                                        id:
                                                                          "question_" +
                                                                          item.messageId,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                " +
                                                                          _vm._s(
                                                                            item
                                                                              .contentList[0]
                                                                          ) +
                                                                          "\n                              "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm
                                                                .tempListTitleMessage[
                                                                index + 1
                                                              ] &&
                                                              _vm
                                                                .tempListTitleMessage[
                                                                index + 1
                                                              ].role ===
                                                                _vm.ROLE_CHAT.ASSISTANT.toString()
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "go-card-desc",
                                                                      staticStyle:
                                                                        {
                                                                          "text-align":
                                                                            "left",
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "go-icon-24 go-icon-letter-a",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              display:
                                                                                "inline",
                                                                            },
                                                                        },
                                                                        _vm._l(
                                                                          _vm
                                                                            .tempListTitleMessage[
                                                                            index +
                                                                              1
                                                                          ]
                                                                            .contentList,
                                                                          function (
                                                                            itemMessage,
                                                                            indexItem
                                                                          ) {
                                                                            return _c(
                                                                              "p",
                                                                              {
                                                                                key:
                                                                                  "answer_" +
                                                                                  item.messageId +
                                                                                  "_" +
                                                                                  indexItem,
                                                                                class:
                                                                                  {
                                                                                    showTextOver:
                                                                                      _vm.noTruncatedIdsList.includes(
                                                                                        item.messageId
                                                                                      ),
                                                                                  },
                                                                                style:
                                                                                  {
                                                                                    marginBottom:
                                                                                      indexItem ===
                                                                                      0
                                                                                        ? "10px"
                                                                                        : "",
                                                                                  },
                                                                                attrs:
                                                                                  {
                                                                                    id:
                                                                                      "answer_" +
                                                                                      item.messageId +
                                                                                      "_" +
                                                                                      indexItem,
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                  " +
                                                                                    _vm._s(
                                                                                      itemMessage
                                                                                    ) +
                                                                                    "\n                                "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.originTruncatedIdsList.includes(
                                                        item.messageId
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                                "justify-content":
                                                                  "flex-end",
                                                              },
                                                            },
                                                            [
                                                              !_vm.truncatedIdsList.includes(
                                                                item.messageId
                                                              )
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      key:
                                                                        "iconNoShowChat_" +
                                                                        item.messageId,
                                                                      attrs: {
                                                                        "aria-expanded":
                                                                          "true",
                                                                        "data-toggle":
                                                                          "collapse",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.handleChangeShowOverText(
                                                                              item.messageId,
                                                                              false
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-tooltip-area",
                                                                          attrs:
                                                                            {
                                                                              "data-toggle":
                                                                                "tooltip",
                                                                              title:
                                                                                _vm.$t(
                                                                                  "modal-create-agent.t11"
                                                                                ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "go-icon-20 go-icon-chevron-up",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "a",
                                                                    {
                                                                      key:
                                                                        "iconShowChat_" +
                                                                        item.messageId,
                                                                      attrs: {
                                                                        "aria-expanded":
                                                                          "true",
                                                                        "data-toggle":
                                                                          "expand",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.handleChangeShowOverText(
                                                                              item.messageId,
                                                                              true
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-tooltip-area",
                                                                          attrs:
                                                                            {
                                                                              "data-toggle":
                                                                                "tooltip",
                                                                              title:
                                                                                _vm.$t(
                                                                                  "modal-create-agent.t12"
                                                                                ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "go-icon-20 go-icon-chevron-down",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("scrap-agent-modal", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.isShowSelectChat &&
                      _vm.currentTab === _vm.allSelectTab[6],
                    expression:
                      "!isShowSelectChat && currentTab === allSelectTab[6]",
                  },
                ],
                ref: "scrapAgentModalRef",
                staticClass: "modal-body",
                attrs: {
                  "is-show-tab": _vm.selectedTab.includes(_vm.allSelectTab[5]),
                  openScrap: true,
                },
                on: {
                  changeFormData: _vm.changeFormDataScrapAgent,
                  handleConnectScrapAgentList: _vm.handleConnectScrapAgentList,
                  markDoneCreateScrapAgent: _vm.markDoneCreateScrapAgent,
                },
              }),
              _vm._v(" "),
              _vm.currentTab === _vm.allSelectTab[0] &&
              _vm.getIsCanShowCreateAgent
                ? _c(
                    "div",
                    {
                      staticClass: "modal-footer",
                      staticStyle: { "margin-top": "-8px" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default go-btn-lg",
                          attrs: {
                            disabled: _vm.isLoading,
                            "data-dismiss": "modal",
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setShowCreateBriefing(false)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("cdHome.t52")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-primary go-btn-lg",
                          attrs: {
                            disabled: _vm.isLoading || _vm.isNextDisabled,
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.nextTab()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("cdHome.t53")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm.getIsCanShowCreateAgent
                ? _c(
                    "div",
                    {
                      staticClass: "modal-footer",
                      staticStyle: { "margin-top": "-8px" },
                    },
                    [
                      _vm.currentTab !== _vm.END_TAB
                        ? [
                            _vm.isShowSelectChat
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn go-btn-default go-btn-lg",
                                    attrs: {
                                      disabled: _vm.isLoading,
                                      type: "button",
                                    },
                                    on: {
                                      click:
                                        _vm.handleBackMenuAndResetCheckedChat,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("cdHome.t52")) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass: "btn go-btn-default go-btn-lg",
                                    attrs: {
                                      disabled: _vm.isLoading,
                                      type: "button",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.prevTab()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("cdHome.t151")) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            !_vm.isShowSelectChat
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn go-btn-primary go-btn-lg",
                                    attrs: {
                                      disabled:
                                        _vm.isNextDisabled ||
                                        _vm.isLoading ||
                                        (_vm.currentTab ===
                                          _vm.allSelectTab[6] &&
                                          _vm.isDisableByScrapModal),
                                      type: "button",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.nextTab()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("scrap-agent.next")) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass: "btn go-btn-primary go-btn-lg",
                                    attrs: {
                                      disabled: _vm.isLoading,
                                      type: "button",
                                    },
                                    on: {
                                      click:
                                        _vm.handleBackMenuAndSaveCheckedChat,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("cdHome.t123")) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                          ]
                        : _vm.currentTab === _vm.END_TAB
                        ? [
                            _vm.LOADING_CREATE.ALL.isUse &&
                            !_vm.LOADING_CREATE.ALL.isLoading &&
                            _vm.LOADING_CREATE.ALL.isSuccess
                              ? _c("div", { staticClass: "go-block-center" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn go-btn-primary go-btn-lg",
                                      attrs: { type: "button" },
                                      on: { click: _vm.closeModal },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("modal-create-agent.t13"))
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", { staticClass: "go-block-center" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn go-btn-primary subscribe go-btn-lg",
                                      attrs: { type: "button" },
                                      on: {
                                        click: _vm.handleRemoveLoadingToast,
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-20 go-icon-subscribe",
                                      }),
                                      _vm._v(" "),
                                      _c("em", [
                                        _vm._v(_vm._s(_vm.$t("cdHome.t171"))),
                                      ]),
                                    ]
                                  ),
                                ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }